export default __webpack_public_path__ + "static/media/nav2.138835bb.svg";